export class FilterRecetaPatient {
  idPaciente: string | null;
  startDate: string | null;
  endDate: string | null;
  dateFilter: string | null;

  constructor(filter: FilterRecetaPatient) {
    this.idPaciente = filter.idPaciente || null;
    this.startDate = filter.startDate || null;
    this.endDate = filter.endDate || null;
    this.dateFilter = filter.dateFilter || null;
  }
}
